import { render, staticRenderFns } from "./CustomReportPage4.vue?vue&type=template&id=4fc8ce1a&scoped=true&"
import script from "./CustomReportPage4.vue?vue&type=script&lang=js&"
export * from "./CustomReportPage4.vue?vue&type=script&lang=js&"
import style0 from "./CustomReportPage4.vue?vue&type=style&index=0&id=4fc8ce1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc8ce1a",
  null
  
)

export default component.exports